import NetxQueryClient, {
	SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';

/**
 * `refreshJwts` request params
 * (what is used to send to server)
 */
export interface RefreshJwtsRequestOptions {
	jwts: string[];
}

/**
 * `refreshJwts` request
 * (what gets sent to the server)
 */
export type RefreshJwtsRequest = [RefreshJwtsRequestOptions['jwts']];

/**
 * `refreshJwts` response
 * (what comes back from the server)
 */
export type RefreshJwtsResponse = SuccessResponse<RefreshJwtsResult>;

/**
 * `refreshJwts` result
 * (what is utilized from the server response)
 */
export type RefreshJwtsResult = string;

export const refreshJwtsEndpoint = 'refreshJwts';

/**
 * Refresh JWTs
 * @param fetchParams Fetch params
 * @returns Refreshed JWTs
 */
export const refreshJwts = async ({jwts}: RefreshJwtsRequestOptions) => {
	const client = NetxQueryClient();

	const requestParams: RefreshJwtsRequest = [jwts];

	return client
		.post<RefreshJwtsResponse>(refreshJwtsEndpoint, requestParams)
		.then((response) => response.data.result);
};
export default refreshJwts;
